import moment from "moment";

export const formatDate = (date: Date, format?: string) => {
  if (!format) {
    format = "MMM DD, YYYY HH:mm A";
  }
  // May 13, 2024 10:50 AM
  return moment(date).format(format);
};
